import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import _ from 'lodash';

import {CSVLink, CSVDownload} from 'react-csv';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import './Report.css';
import ReportStyles from './ReportStyles';

import { FetchXHR } from '../../Helpers/generals';

const defaultProps = {
    reportData: []
};

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class Report extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: Number(moment().format('YYYY')),
            trimester: Math.round(moment().get('month')/3),
            width: 500,
            height: 300,
            data: this.props.reportData,
            dataReport: {},
            downloadReport: false
        }

        this.handleChangeYear = this.handleChangeYear.bind(this);
        this.handleChangeTrimester = this.handleChangeTrimester.bind(this);
        this.handleChangeParam = this.handleChangeParam.bind(this);

        this.saveReport = this.saveReport.bind(this);
        this.downloadReport = this.downloadReport.bind(this);

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }
    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        this.props.onReloadData(this.state.year, this.state.trimester);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reportData) {
            if (nextProps.isFromAnalytics) {
                let oldData = JSON.parse(JSON.stringify(this.state.data));
                let newData = [];
                oldData.forEach((old) => {
                    if (old.category === 'Indicadores Manuales') {
                        newData.push(old);
                    }
                });
                nextProps.reportData.forEach((nd) => {
                    if (nd.category !== 'Indicadores Manuales') {
                        newData.push(nd)
                    }
                });
                this.setState({
                    data: newData
                });
            } else {
                this.setState({
                    data: nextProps.reportData
                });
            }

        }

    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    }

    handleChangeYear(event, index, value) {
        this.props.onReloadData(value, this.state.trimester);
        this.setState({
            year: value
        });
    }

    handleChangeTrimester(event, index, value) {
        this.props.onReloadData(this.state.year, value);
        this.setState({
            trimester: value
        });
    }

    handleChangeParam(event) {
        const value = event.target.value;
        if (isNumber(value) || value === '') {
            const parameter_id = Number(event.target.id);
            const actualStateData = JSON.parse(JSON.stringify(this.state.data));
            let indice = -1;
            actualStateData.forEach((obj, i) => {
                if (obj.id === parameter_id) {
                    indice = i;
                }
            });
            if (indice >= 0) {
                actualStateData[indice].reportValue = value;
            }
            this.setState({
                data: actualStateData
            });
        }

    }

    saveReport() {
        const url = 'https://agua.org.mx/monitorservice/reports';
        const postData = JSON.parse(JSON.stringify(this.state.data));
        FetchXHR(url, 'PUT', { year: this.state.year, trimester: this.state.trimester, reports: postData }).then((response) => {
            if (response.json.success) {
                this.props.onReloadData(this.state.year, this.state.trimester);
                alert("Reporte actualizado correctamente.");
            }
        }).catch((onError) => {
            console.log(onError);
        });
    }
    downloadReport() {
        // get params by year&Trimester
        const url = 'https://agua.org.mx/monitorservice/csvreport';
        const postData = {
            year: this.state.year,
            trimester: 0
        };
        FetchXHR(url, 'POST', postData).then((response) => {
            if (response.json.data) {
                if (response.json.data.headers.length > 0 && response.json.data.body.length > 0) {
                    this.setState({
                        downloadReport: true,
                        dataReport: { headers: response.json.data.headers, body: response.json.data.body }
                    });
                    setTimeout(() => {
                        this.setState({
                            downloadReport: false
                        });
                    }, 5000);
                }else{
                    console.log("EmptyReport");
                }
            }
        }).catch((onError) => {
            console.log(onError);
        });
    }
    render() {
        const tableData = {}
        this.state.data.forEach((parameter)=> {
            if(tableData[parameter.category] == undefined) {
                tableData[parameter.category] = [];
            }
            let val = 0;
            if (parameter.reportValue != -1) {
                val = parameter.reportValue;
            }
            tableData[parameter.category].push({
                id: parameter.reportID,
                parameter_id: parameter.id,
                name: parameter.name,
                value: val
            });
        });
        this.formFields = Object.keys(tableData).map((k) => {
            return ({
                category: k,
                parameters: tableData[k]
            });
        });

        var listSections = [];

        this.formFields.forEach((section) => {
            const textfields = section.parameters.map((txtf)=>{
                return (
                    <TableRow style = {{ textAlign: 'center' }}>
                        <TableRowColumn colSpan={2} style={{ textAlign: 'center' }} >{txtf.parameter_id}</TableRowColumn>
                        <TableRowColumn colSpan={5} style={{ textAlign: 'left' }} >{txtf.name}</TableRowColumn>
                        <TableRowColumn colSpan={3} style={{ textAlign: 'center' }} > <TextField style={{ textAlign: 'center', width: 150 }} onChange={this.handleChangeParam} id={String(txtf.parameter_id)} value={txtf.value} /> </TableRowColumn>
                    </TableRow>
                );
            });

            listSections.push(
                <TableRow key={section.category} striped={true} style = {{ textAlign: 'center' }} >
                    <TableRowColumn colSpan={2} style={{ textAlign: 'center' }} ></TableRowColumn>
                    <TableRowColumn colSpan={5} style={{ textAlign: 'center' }} ><b style={{ fontSize: 16, textAlign: 'center' }}> {section.category} </b></TableRowColumn>
                    <TableRowColumn colSpan={3} style={{ textAlign: 'center' }} ></TableRowColumn>
                </TableRow>);
            listSections.push(textfields);
        });

        const sections = <TableBody
            displayRowCheckbox={false}
            stripedRows={false}
        >
            {listSections}
        </TableBody>;

        let downloadcsv = <div></div>;
        if (this.state.downloadReport) {
            downloadcsv = <CSVDownload data={this.state.dataReport.body} headers={this.state.dataReport.headers} /> ;
        }

        return (
            <div className="reportContainer">
                <div style={ReportStyles.dropdownsContainer}>
                    {downloadcsv}
                    <DropDownMenu
                        value={this.state.year}
                        onChange={this.handleChangeYear}
                        style={{color: 'white', width: 300}}
                        iconStyle={{color: 'green'}}
                        underlineStyle={{color: 'green'}}
                        autoWidth={false}
                    >
                        <MenuItem value={2017} primaryText="2017" />
                        <MenuItem value={2018} primaryText="2018" />
                        <MenuItem value={2019} primaryText="2019" />
                        <MenuItem value={2020} primaryText="2020" />
                        <MenuItem value={2021} primaryText="2021" />
                        <MenuItem value={2022} primaryText="2022" />
                    </DropDownMenu>
                    <DropDownMenu
                        value={this.state.trimester}
                        onChange={this.handleChangeTrimester}
                        style={{width: 300}}
                        autoWidth={false}
                    >
                        <MenuItem value={1} primaryText="1 Trimestre" />
                        <MenuItem value={2} primaryText="2 Trimestre" />
                        <MenuItem value={3} primaryText="3 Trimestre" />
                        <MenuItem value={4} primaryText="4 Trimestre" />
                    </DropDownMenu>
                    <div>
                        <RaisedButton
                            backgroundColor="#4C75BC"
                            labelColor="#FFFFFF"
                            style={ReportStyles.searchButton}
                            label="Guardar"
                            onClick={() => {
                                this.saveReport();
                            }}
                        />
                        <RaisedButton
                            backgroundColor="#4C75BC"
                            labelColor="#FFFFFF"
                            style={ReportStyles.searchButton}
                            label="Descargar"
                            onClick={() => {
                                this.downloadReport();
                            }}
                        />
                    </div>
                </div>
                <div style={{ width: this.state.width }} className="reportList">
                    <Table
                        selectable={false}
                        multiSelectable={false}
                        style={{ width: this.state.width }}
                    >
                        <TableHeader
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                            enableSelectAll={false}
                        >
                            <TableRow>
                                <TableHeaderColumn colSpan={2} style={{ color: '#E91E63', textAlign: 'center' }}>ID</TableHeaderColumn>
                                <TableHeaderColumn colSpan={5} style={{ color: '#E91E63', textAlign: 'center' }}>Nombre</TableHeaderColumn>
                                <TableHeaderColumn colSpan={3} style={{ color: '#E91E63', textAlign: 'center' }}>Valor</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        {sections}
                    </Table>
                </div>
            </div>
        );
    }
}

Report.defaultProps = defaultProps;

export default Report;



// WEBPACK FOOTER //
// ./src/Components/Report/Report.jsx